module.exports = __webpack_public_path__ + "static/img/iconTheJinn.e62dc15.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconTheJinn.svg
// module id = LiH4
// module chunks = 1